// Slider 
import Glide from '@glidejs/glide';
new Glide('#diversity-slide', {
  type: 'carousel',
  gap: 20,
  perView: 3,
  breakpoints: {
    1049: {
      perView: 1,
    },
  },
}).mount();


// Accordion
  function initAccordion() {
  const accordionList = document.querySelectorAll('.accordion-button');

  function toggleAccordion() {
    closeOthers(this);
  
    if(this.getAttribute("aria-expanded") === "false") {
      this.setAttribute("aria-expanded", "true");
      this.nextElementSibling.setAttribute("aria-hidden", "false");
    } else {
      this.setAttribute("aria-expanded", "false");
      this.nextElementSibling.setAttribute("aria-hidden", "true");
    }
  }
  
  function closeOthers(target) {
    accordionList.forEach(item => {
      if(item != target) {
        item.setAttribute("aria-expanded", "false");
        item.nextElementSibling.setAttribute("aria-hidden", "true");
      }
    });
  }
  
  accordionList.forEach(item => {
    item.addEventListener("click", toggleAccordion)
  });
}

initAccordion()

// Menu Hamburguer
function menu() {
  const menu = document.querySelector('.menu');
  const menuItem = document.querySelectorAll('.menu__list__item');
  const btnToggle = document.querySelector('.menu__toggle');

  function openMenu(){
    menu.classList.add('menu--active');
    btnToggle.setAttribute('aria-expanded', true);
    btnToggle.setAttribute('aria-label', 'Fechar Menu');
  }

  function closeMenu() {
    menu.classList.remove('menu--active');
    btnToggle.setAttribute('aria-expanded', false);
    btnToggle.setAttribute('aria-label', 'Abrir Menu');
  }

  function toggleMenu() {
    const menuActive = menu.classList.contains('menu--active');

    if (!menuActive) {
      openMenu()
    } else {
      closeMenu()
    }
  }

  btnToggle.addEventListener('click', toggleMenu);
  
  menuItem.forEach(item => {
    item.addEventListener('click', closeMenu);
  });

}

menu()

// Animation
const sectionAnimation = () => {
  const sections = document.querySelectorAll('[data-animate]');  
  
  sections.forEach(section => {
    const halfWindow = window.innerHeight * 0.6;
    const isSectionVisible = (section.getBoundingClientRect().top - halfWindow) < 0;

    if(isSectionVisible) {
      section.setAttribute("data-animate", "true");
    }
  });  
}

window.addEventListener('scroll', sectionAnimation);